import * as React from "react";
import type { SVGProps } from "react";
const SvgUser = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={23}
    fill="none"
    {...props}
  >
    <path
      fill="#74758C"
      d="M10.2 11.425c3.1 0 5.7-2.5 5.7-5.7s-2.5-5.6-5.7-5.6c-3.1 0-5.6 2.5-5.6 5.7s2.5 5.6 5.6 5.6m0-9.9c2.3 0 4.3 1.9 4.3 4.3s-1.9 4.3-4.3 4.3c-2.3-.1-4.2-2-4.2-4.3s1.9-4.3 4.2-4.3M17.2 21.425H2.4c-.4 0-.7-.3-.7-.7v-1.8c0-2.5 2-4.5 4.5-4.5.9 0 1.7.7 4 .7 2.2 0 3.1-.7 4-.7 2.3 0 4.2 1.8 4.5 4 .2-.1.5-.1.8-.1.2 0 .5 0 .7.1-.3-3-2.8-5.4-5.9-5.4-1.3 0-1.9.7-4 .7s-2.7-.7-4-.7c-3.3 0-6 2.7-6 6v1.8c0 1.2 1 2.1 2.1 2.1h16c-.5-.4-1-.9-1.2-1.5"
    />
    <path
      fill="#18A09F"
      d="M19.6 19.125c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5 1.5-.7 1.5-1.5-.7-1.5-1.5-1.5"
    />
  </svg>
);
export default SvgUser;
